var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.record && _vm.record.uuid)?[_c('a',{attrs:{"href":_vm.base_url+'/'+_vm.record.uuid}},[_c('span',{staticClass:"badge badge-success"},[_vm._v("ONLINE "+_vm._s(_vm._f("timeago")(_vm._f("dateTimezone")(_vm.record.created_at))))])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }